import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowboardNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M20.736 2.006a6.547 6.547 0 019.259 9.259l-.022.022c-1.49 1.488-3.237 2.997-4.94 4.47l-.021.018c-1.735 1.5-3.425 2.961-4.85 4.386s-2.886 3.115-4.386 4.85l-.018.02c-1.47 1.701-2.978 3.445-4.464 4.934l-.028.028a6.547 6.547 0 01-9.259-9.26l.002-.001.015-.015c1.491-1.49 3.24-3 4.945-4.475l.02-.018c1.736-1.5 3.426-2.961 4.85-4.386s2.887-3.115 4.387-4.85l.018-.02c1.471-1.703 2.98-3.448 4.467-4.937V2.03l.022-.022zm1.769 1.766l-.002.001-.02.02-.002.003c-1.418 1.42-2.872 3.101-4.364 4.827l-.422.488a1.998 1.998 0 011.57.331l3.3 2.357a2 2 0 01.778 2.114l.034-.03c1.727-1.492 3.409-2.947 4.83-4.365l.003-.005.017-.016a4.047 4.047 0 00-5.722-5.725zm-8.898 9.834a64.376 64.376 0 01-2.842 2.645 1.996 1.996 0 011.455.466l3.064 2.593c.505.428.743 1.048.704 1.656a61.515 61.515 0 012.406-2.573 60.157 60.157 0 012.434-2.282 1.995 1.995 0 01-1.528-.583L16.472 12.7a1.995 1.995 0 01-.583-1.528 60 60 0 01-2.282 2.434zM8.757 18l-.111.097-.021.018c-1.729 1.495-3.413 2.951-4.834 4.37l-.001.002-.015.015a4.047 4.047 0 105.724 5.723l.02-.02.006-.006c1.39-1.394 2.817-3.039 4.279-4.73a2 2 0 01-2.036-.643l-2.593-3.064A1.999 1.999 0 018.758 18z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowboardNormalMedium;
